import { useCallback, useMemo } from 'react';

function hash(str: string) {
  let h = 5381;
  let i = str.length;

  while (i) {
    h = (h * 33) ^ str.charCodeAt(--i);
  }

  return h >>> 0;
}

const maxHashValue = 4294967295;

function hashToNumberBetween(str: string, begin = 0, end = 100) {
  const hashValue = hash(str);
  const range = end - begin;
  const percent = hashValue / maxHashValue;
  return Math.floor(begin + range * percent);
}

export const useGetRandomProfilePicture = () => {
  return useCallback((uniqueId: string) => {
    const id = uniqueId ?? '00000000-0000-0000-0000-000000000000';
    const gender = parseInt(id[0], 16) < 8 ? 'men' : 'women';
    const uniqueIdHash = hashToNumberBetween(id, 0, 100);
    return `https://randomuser.me/api/portraits/${gender}/${uniqueIdHash}.jpg`;
  }, []);
};

export const useRandomProfilePicture = (uniqueId: string) => {
  const getPicture = useGetRandomProfilePicture();
  return useMemo(() => getPicture(uniqueId), [getPicture, uniqueId]);
};
